(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["purchase-checklist"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('store-checklist')) {
  customElements.define('store-checklist', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.inputs = [...this.querySelectorAll('input[type="checkbox"]')];
      this.key = 'store-checklist:v1:' + this.dataset.key;
      this.status = this.querySelector('[data-checklist-status]');
      try {
        const saved = JSON.parse(localStorage.getItem(this.key) || '[]');
        if (Array.isArray(saved)) this.inputs.forEach(input => { input.checked = saved.includes(input.value); });
      } catch (_) {}
      this.updateCount();
      this.addEventListener('change', event => {
        if (!this.inputs.includes(event.target)) return;
        this.save();
      });
      this.querySelector('[data-checklist-reset]')?.addEventListener('click', () => {
        this.inputs.forEach(input => { input.checked = false; });
        this.save(true);
      });
      this.querySelector('[data-checklist-reset]')?.removeAttribute('hidden');
      this.querySelector('[data-checklist-progress]')?.removeAttribute('hidden');
    }
    updateCount() {
      const checked = this.inputs.filter(input => input.checked);
      const count = this.querySelector('[data-checklist-count]');
      if (count) count.textContent = checked.length + ' / ' + this.inputs.length;
      return checked.map(input => input.value);
    }
    save(clear = false) {
      const checked = this.updateCount();
      let message = clear ? this.dataset.cleared : this.dataset.saved;
      try {
        if (clear) localStorage.removeItem(this.key);
        else localStorage.setItem(this.key, JSON.stringify(checked));
      } catch (_) {
        message = this.dataset.temporary;
      }
      if (this.status) this.status.textContent = message;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retail-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('retail-finder')) {
  document.addEventListener('formdata', event => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const action = new URL(event.target.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname) || !event.formData.has('id')) return;
    const finder = document.querySelector('retail-finder');
    if (!finder?.querySelector('[data-attach-profile]')?.checked) return;
    const profile = finder.profiles?.find(item => item.id === finder.profileSelect?.value);
    const label = typeof profile?.label === 'string' ? profile.label.slice(0, 600) : '';
    if (label) event.formData.set('properties[' + finder.text('order_property') + ']', label);
  }, true);

  customElements.define('retail-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.config = JSON.parse(this.querySelector('[data-finder-config]').textContent);
      this.key = 'visit-retail-profiles:v1:' + this.config.kind;
      this.status = this.querySelector('[data-status]');
      this.result = this.querySelector('[data-result]');
      this.profileSelect = this.querySelector('[data-profiles]');
      this.profiles = [];
      try {
        const saved = JSON.parse(localStorage.getItem(this.key) || '[]');
        if (Array.isArray(saved)) this.profiles = saved.filter(p => p && typeof p.id === 'string' && p.values && typeof p.values === 'object').slice(0, 5);
      } catch (_) {}
      this.querySelector('[data-interactive]').hidden = false;
      this.profileOptions();
      this.form.addEventListener('submit', e => {
        e.preventDefault();
        if (!this.form.reportValidity()) return;
        this.showResults();
      });
      this.form.addEventListener('input', () => { this.clearOrderAttachment(); this.calculate(); });
      this.form.addEventListener('change', e => {
        this.clearOrderAttachment();
        if (e.target.matches('[data-vehicle-parent]')) this.loadModels();
        if (e.target.name === 'manual') this.toggleManual();
        if (this.result.hidden === false) {
          if (this.form.checkValidity()) this.showResults(false);
          else this.result.hidden = true;
        }
        this.calculate();
      });
      this.querySelector('[data-save]').addEventListener('click', () => this.save());
      this.querySelector('[data-clear]').addEventListener('click', () => this.clear());
      this.querySelector('[data-delete]').addEventListener('click', () => this.remove());
      this.profileSelect.addEventListener('change', () => this.restore(this.profileSelect.value));
      if (this.config.kind === 'vehicle') this.toggleManual();
      if (this.profiles.length) this.restore(this.profiles[0].id);
      this.querySelector('[data-noscript]').hidden = true;
    }
    text(key, vars = {}) {
      return Object.entries(vars).reduce((s, [k, v]) => s.replaceAll('{' + k + '}', String(v)), this.config.text[key] || '');
    }
    values() {
      const data = {};
      for (const element of this.form.elements) {
        if (!element.name || element.disabled) continue;
        data[element.name] = element.type === 'checkbox' ? element.checked : element.value.slice(0, 160);
      }
      if (this.config.kind === 'vehicle' && !data.manual) {
        data.make_label = this.form.elements.make.selectedOptions[0]?.textContent || '';
      }
      return data;
    }
    describe(v) {
      if (this.config.kind === 'vehicle') return [v.year, v.manual ? v.make_manual : v.make_label, v.manual ? v.model_manual : v.model, v.engine].filter(Boolean).join(' · ');
      return this.config.fields.map(name => {
        const el = this.form.elements[name];
        return [...el.options].find(o => o.value === v[name])?.textContent;
      }).filter(Boolean).join(' · ');
    }
    clearOrderAttachment() {
      const attach = this.querySelector('[data-attach-profile]');
      if (attach) { attach.checked = false; attach.disabled = true; }
    }
    profileOptions(selected = '') {
      this.clearOrderAttachment();
      const attach = this.querySelector('[data-attach-profile]');
      if (attach) attach.disabled = !selected;
      this.profileSelect.replaceChildren(new Option(this.text('new_profile'), ''));
      this.profiles.forEach(p => this.profileSelect.add(new Option(p.label || this.text('saved_profile'), p.id)));
      this.profileSelect.value = selected;
      this.querySelector('[data-delete]').disabled = !selected;
      this.querySelector('[data-profile-controls]').hidden = this.profiles.length === 0;
    }
    persist(message) {
      try {
        if (this.profiles.length) localStorage.setItem(this.key, JSON.stringify(this.profiles));
        else localStorage.removeItem(this.key);
        this.status.textContent = this.text(message);
      } catch (_) { this.status.textContent = this.text('temporary'); }
    }
    save() {
      if (!this.form.reportValidity()) return;
      const v = this.values();
      if (this.config.kind === 'vehicle' && (!v.year || (v.manual ? !v.make_manual?.trim() || !v.model_manual?.trim() : !v.make || !v.model))) { this.status.textContent = this.text('manual_help'); return; }
      const id = this.profileSelect.value || (globalThis.crypto?.randomUUID?.() || String(Date.now()));
      if (!this.profileSelect.value && this.profiles.length >= 5) { this.status.textContent = this.text('limit'); return; }
      this.profiles = [{ id, values: v, label: this.describe(v) }, ...this.profiles.filter(p => p.id !== id)];
      this.profileOptions(id);
      this.persist('saved');
      this.querySelector('[data-saved-summary]').textContent = this.describe(v);
      this.showResults();
    }
    restore(id) {
      const profile = this.profiles.find(p => p.id === id);
      if (!profile) { this.clear(); return; }
      this.modelRequest = (this.modelRequest || 0) + 1;
      this.form.reset();
      const v = profile.values;
      for (const element of this.form.elements) {
        if (!element.name || !(element.name in v)) continue;
        if (element.type === 'checkbox') element.checked = v[element.name] === true;
        else {
          if (element.name === 'model' && element.tagName === 'SELECT') element.replaceChildren(new Option(String(v.model), String(v.model)));
          element.value = String(v[element.name]).slice(0, 160);
        }
      }
      if (this.config.kind === 'vehicle') {
        this.form.elements.model.disabled = false;
        this.toggleManual();
      }
      this.profiles = [profile, ...this.profiles.filter(p => p.id !== id)];
      this.profileOptions(id);
      this.querySelector('[data-saved-summary]').textContent = profile.label || '';
      this.persist('restored');
      if (this.form.checkValidity()) this.showResults(false);
      this.calculate();
    }
    clear() {
      this.modelRequest = (this.modelRequest || 0) + 1;
      this.form.reset();
      if (this.config.kind === 'vehicle') {
        this.form.elements.model.replaceChildren(new Option(this.text('choose_model'), ''));
        this.form.elements.model.disabled = true;
        this.toggleManual();
      }
      this.profileOptions();
      this.result.hidden = true;
      this.querySelector('[data-saved-summary]').textContent = '';
      this.status.textContent = this.text('cleared');
      this.calculate();
    }
    remove() {
      const id = this.profileSelect.value;
      if (!id) return;
      this.profiles = this.profiles.filter(p => p.id !== id);
      this.clear();
      this.persist('removed');
    }
    toggleManual() {
      const manual = this.form.elements.manual.checked;
      this.querySelector('[data-manual-fields]').hidden = !manual;
      this.querySelector('[data-lookup-fields]').hidden = manual;
      ['make_manual', 'model_manual'].forEach(name => {
        this.form.elements[name].disabled = !manual;
        this.form.elements[name].required = manual;
      });
      this.form.elements.make.disabled = manual;
      this.form.elements.make.required = !manual;
      this.form.elements.model.disabled = manual || !this.form.elements.model.value && this.form.elements.model.options.length < 2;
      this.form.elements.model.required = !manual;
      if (manual) this.modelRequest = (this.modelRequest || 0) + 1;
    }
    async loadModels() {
      const request = this.modelRequest = (this.modelRequest || 0) + 1;
      const year = this.form.elements.year.value;
      const make = this.form.elements.make.value;
      const model = this.form.elements.model;
      model.replaceChildren(new Option(this.text('choose_model'), ''));
      model.disabled = true;
      this.form.elements.engine.value = '';
      this.result.hidden = true;
      if (this.form.elements.manual.checked || !year || !make) return;
      if (Number(year) < 1996) { this.status.textContent = this.text('manual_help'); return; }
      this.status.textContent = this.text('loading');
      try {
        const response = await fetch('https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMakeIdYear/makeId/' + encodeURIComponent(make) + '/modelyear/' + encodeURIComponent(year) + '?format=json', { signal: AbortSignal.timeout(12000), credentials: 'omit' });
        if (!response.ok) throw new Error('lookup');
        const json = await response.json();
        if (request !== this.modelRequest || !this.isConnected) return;
        const names = [...new Set((json.Results || []).map(x => x.Model_Name).filter(x => typeof x === 'string' && x.trim()))].sort((a,b) => a.localeCompare(b));
        if (!names.length) throw new Error('empty');
        names.forEach(name => model.add(new Option(name, name)));
        model.disabled = false;
        this.status.textContent = this.text('models_ready');
      } catch (_) {
        if (request === this.modelRequest) this.status.textContent = this.text('manual_help');
      }
    }
    showResults(focus = true) {
      const v = this.values();
      if (this.config.kind === 'vehicle' && (!v.year || (v.manual ? !v.make_manual?.trim() || !v.model_manual?.trim() : !v.make || !v.model))) {
        this.status.textContent = this.text('manual_help');
        return;
      }
      const choices = this.config.fields.map(name => this.form.elements[name].selectedOptions[0]);
      const tips = this.querySelector('[data-tips]');
      tips.replaceChildren();
      choices.forEach(option => {
        if (!option?.dataset.tip) return;
        const li = document.createElement('li'); li.textContent = option.dataset.tip; tips.append(li);
      });
      const scores = new Map();
      choices.forEach((option, index) => {
        const weight = this.config.kind === 'pet' && index === 2 || this.config.kind === 'print' && index === 1 ? 3 : index === 0 ? 2 : 1;
        (option?.dataset.routes || '').split(' ').filter(Boolean).forEach(handle => scores.set(handle, (scores.get(handle) || 0) + weight));
      });
      const primaryIndex = this.config.kind === 'pet' ? 2 : ['home','print'].includes(this.config.kind) ? 1 : 0;
      let allowed = new Set((choices[primaryIndex]?.dataset.routes || '').split(' ').filter(Boolean));
      if (this.config.kind === 'fitness' && ['small','portable'].includes(v.space)) {
        const spaceRoutes = (choices[1]?.dataset.routes || '').split(' ');
        allowed = new Set([...allowed].filter(handle => spaceRoutes.includes(handle)));
      }
      const links = [...this.querySelectorAll('[data-route]')];
      const eligible = links.filter(link => {
        if (!allowed.has(link.dataset.route)) return false;
        if (this.config.kind !== 'pet') return true;
        return !(v.pet === 'dog' && link.dataset.route.startsWith('cat-')) && !(v.pet === 'cat' && link.dataset.route.startsWith('dog-'));
      });
      const ranked = eligible.filter(link => scores.has(link.dataset.route)).sort((a,b) => scores.get(b.dataset.route) - scores.get(a.dataset.route));
      const winners = ranked.slice(0, 4);
      links.forEach(link => { link.hidden = !winners.includes(link); });
      winners.forEach(link => this.querySelector('[data-links]').append(link));
      this.querySelector('[data-result-summary]').textContent = this.describe(v);
      this.result.hidden = false;
      if (focus) this.querySelector('[data-result-title]').focus({preventScroll: true});
    }
    calculate() {
      const output = this.querySelector('[data-calculation]');
      if (!output) return;
      const get = name => {
        const el = this.form.elements[name];
        return el && el.value !== '' && el.validity.valid && Number.isFinite(Number(el.value)) && Number(el.value) > 0 ? Number(el.value) : null;
      };
      const mode = this.config.calc;
      let text = this.text('calc_hint');
      const round = x => new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits: 1}).format(x);
      if (mode === 'supply') {
        const kg = get('bag'), grams = get('daily');
        if (kg && grams) text = this.text('supply_result', {days: round(kg * 1000 / grams)});
      }
      if (mode === 'storage') {
        const shelf = get('shelf'), bin = get('bin'), gap = Number(this.form.elements.gap.value || 0);
        if (shelf && bin && Number.isFinite(gap) && gap >= 0 && this.form.elements.gap.validity.valid) text = this.text('storage_result', {count: Math.floor((shelf + gap) / (bin + gap))});
      }
      if (mode === 'footprint') {
        const sw = get('space_width'), sd = get('space_depth'), iw = get('item_width'), id = get('item_depth');
        const visual = this.querySelector('[data-footprint]');
        visual.hidden = !(sw && sd && iw && id);
        if (sw && sd && iw && id) {
          const fits = iw <= sw && id <= sd;
          text = this.text(fits ? 'footprint_inside' : 'footprint_outside', {width: round(sw - iw), depth: round(sd - id)});
          const rect = this.querySelector('[data-item-rect]');
          const scale = Math.min(260 / Math.max(sw,iw), 180 / Math.max(sd,id));
          this.querySelector('[data-space-rect]').setAttribute('width', sw * scale);
          this.querySelector('[data-space-rect]').setAttribute('height', sd * scale);
          rect.setAttribute('width', iw * scale);
          rect.setAttribute('height', id * scale);
        }
      }
      if (mode === 'print') {
        const width = get('print_width'), height = get('print_height'), pw = get('pixel_width'), ph = get('pixel_height');
        if (width && height && pw && ph) {
          const ratio = pw / ph, target = width / height;
          text = this.text('print_result', {ppi: round(Math.min(pw / width, ph / height))}) + ' ' + this.text(Math.abs(ratio - target) / target > 0.01 ? 'ratio_different' : 'ratio_match');
        }
      }
      output.textContent = text;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopping-paths"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('store-checklist')) {
  customElements.define('store-checklist', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.inputs = [...this.querySelectorAll('input[type="checkbox"]')];
      this.key = 'store-checklist:v1:' + this.dataset.key;
      this.status = this.querySelector('[data-checklist-status]');
      try {
        const saved = JSON.parse(localStorage.getItem(this.key) || '[]');
        if (Array.isArray(saved)) this.inputs.forEach(input => { input.checked = saved.includes(input.value); });
      } catch (_) {}
      this.updateCount();
      this.addEventListener('change', event => {
        if (!this.inputs.includes(event.target)) return;
        this.save();
      });
      this.querySelector('[data-checklist-reset]')?.addEventListener('click', () => {
        this.inputs.forEach(input => { input.checked = false; });
        this.save(true);
      });
      this.querySelector('[data-checklist-reset]')?.removeAttribute('hidden');
      this.querySelector('[data-checklist-progress]')?.removeAttribute('hidden');
    }
    updateCount() {
      const checked = this.inputs.filter(input => input.checked);
      const count = this.querySelector('[data-checklist-count]');
      if (count) count.textContent = checked.length + ' / ' + this.inputs.length;
      return checked.map(input => input.value);
    }
    save(clear = false) {
      const checked = this.updateCount();
      let message = clear ? this.dataset.cleared : this.dataset.saved;
      try {
        if (clear) localStorage.removeItem(this.key);
        else localStorage.setItem(this.key, JSON.stringify(checked));
      } catch (_) {
        message = this.dataset.temporary;
      }
      if (this.status) this.status.textContent = message;
    }
  });
}

if (!customElements.get('store-shopping-paths')) {
  customElements.define('store-shopping-paths', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const search = this.querySelector('[data-path-search]');
      const paths = [...this.querySelectorAll('[data-shopping-path]')];
      const empty = this.querySelector('[data-path-empty]');
      const count = this.querySelector('[data-path-count]');
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const filter = () => {
        const terms = normalize(search.value).split(/\s+/).filter(Boolean);
        let visible = 0;
        paths.forEach(path => {
          const words = normalize(path.dataset.search);
          path.hidden = !terms.every(term => words.includes(term));
          if (!path.hidden) visible++;
          else path.open = false;
        });
        empty.hidden = visible !== 0;
        count.textContent = visible + ' / ' + paths.length;
      };
      this.querySelector('[data-path-controls]').hidden = false;
      search.addEventListener('input', filter);
      search.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        const first = paths.find(path => !path.hidden);
        if (first) {
          first.open = true;
          first.querySelector('summary').focus();
        }
      });
      this.querySelector('[data-path-clear]').addEventListener('click', () => {
        search.value = '';
        filter();
        search.focus();
      });
      filter();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
